<template>
  <el-row
    :gutter="24"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <el-col
      :span="10"
      :offset="7"
      :xs="{span:18, offset: 3}"
    >
      <el-form
        :model="form"
        :rules="rules"
        :ref="formName"
        label-position="top"
        class="login-form"
        autocomplete="off"
        @submit.native.prevent
      >
        <LoginForm
          :dob.sync="form.dateOfBirth"
          ref="loginForm"
          @sendData="submitForm"
        />
        <el-form-item class="submit-btn">
          <el-button
            type="primary"
            @click="submitForm('Login')"
          >
            Login
          </el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>

import LoginForm from "./components/LoginForm";

export default {
  name: "Login",
  components: {
    LoginForm
  },
  data: () => ({
    fullscreenLoading: false,
    sid: null,
    formName: 'Login',
    form: {
      dateOfBirth: "",
    },
    rules: {
      dateOfBirth: [
        { required: true, message: "Please enter Date of Birth", trigger: "blur" },
      ],
    },
    patientNumber: null,
  }),
  created() {
    this.sid = this.setSessionId();
    this.saveStatisticData(this.sid, {
      load_form: 'true',
      pir: this.$route.params.pir
    });
  },
  methods: {
    submitForm () {
      this.$refs.loginForm.validDate = true;
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          if (this.$refs.loginForm.checkDate(this.form.dateOfBirth)) {
            this.login();
          } else {
            this.fullscreenLoading = false;
            return false;
          }
        }
      });
      return false;
    },
    login () {
      this.fullscreenLoading = true;
      this.$axios("/Patient/Authenticate", {
        method: "POST",
        data: {
          dateOfBirth: this.form.dateOfBirth,
          encodedNumber: this.$route.params.pir,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          sessionStorage.setItem("patientApiToken", response.data.data.accessToken);
          sessionStorage.removeItem("authSource");
          const token = this.parseToken(response.data.data.accessToken),
                pathData = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
          this.saveStatisticData(this.sid, {
            login: 'true',
            patient_number: token.patient_number,
          });
          if (pathData[1]) {
            this.$router.push({
              name: pathData[1].charAt(0).toUpperCase() + pathData[1].slice(1),
              params: {
                patientNumber: token.patient_number,
                token: this.$route.params.token,
                type: this.$route.params.type
              },
            });
          } else {
            this.$router.push({
              name: "UpdateInfo",
              params: {
                patientNumber: token.patient_number,
                token: this.$route.params.token,
                tab: this.$route.params.tab,
              },
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: "Can't get your personal data!",
            type: "error",
          });
        }
        this.fullscreenLoading = false;
      }).catch(() => {
        this.fullscreenLoading = false;
        this.$message({
          showClose: true,
          message: "Please enter the correct data!",
          type: "error",
        });
      });
    },
  },
};
</script>

